import React, { useState, useEffect, useRef } from "react";
import PopStyle from "../../style/PopUp.module.css";
import Style from "../../style/components/chat/ChatMension.module.css";
import { CiSearch } from "react-icons/ci";
import { useMenstionUserLst } from "../../hooks/useMension";
import FallbackAvatar from "../ui/FallbackAvatar/FallbackAvatar";

const ChatMension = ({ Onclose, onSelectUser }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const { user } = useMenstionUserLst(searchTerm);

  const apiUrl = process.env.REACT_APP_API_URL;
  const popupRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        Onclose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [Onclose]);

  return (
    <div className={PopStyle.popupBackgroundNormal}>
      <div className={Style.ChatMentionMain} ref={popupRef}>
        <div className={Style.ChatMentionContainer}>
          <div className={Style.searchContainer}>
            <input
              type="text"
              placeholder="Search users..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={Style.searchInput}
            />
            <CiSearch size={16} className={Style.searchIcon} />
          </div>

          <div className={Style.usersList}>
            {user.length > 0 ? (
              user.map((user) => (
                <div
                  key={user.id}
                  className={Style.userItem}
                  onClick={() => {
                    onSelectUser(user);
                    Onclose();
                  }}
                >
                  <div className={Style.avatar}>
                    {user?.emp_pic !== null ? (
                      <img
                        src={`${apiUrl}${user.emp_pic}`}
                        className={Style.avatarImg}
                        alt="img"
                      />
                    ) : (
                      <FallbackAvatar name={user.first_name} size={30} />
                    )}
                    {user.online_status && (
                      <span className={Style.onlineIndicator}></span>
                    )}
                  </div>
                  <div className={Style.userName}>{user.name}</div>
                </div>
              ))
            ) : (
              <div className={Style.noResults}>No users found</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatMension;
